/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 *  Possible values: Web = 1, Chatbot = 2, Internal = 3, VoiceBot = 4
 */
export enum Routemize_Constants_RequestOrigin {
    WEB = 'Web',
    CHATBOT = 'Chatbot',
    INTERNAL = 'Internal',
    VOICE_BOT = 'VoiceBot',
}
